const promo = {
  // ongoing: 'Ongoing Campaigns',
  ongoing: 'Ongoing',
  games:'Games',
  empty: 'Ongoing Campaigns',
  title: 'Title',
  type: 'Type',
  past:'Past',
  add: 'Add Campaign',
  campaigns: 'Campaigns',
  monitoring: {
    views: 'Viewship rate',
    clicks: 'Clickthrough rate',
  },
  views: 'Views',
  card: {
    campaign: {
      title: 'Campaign',
      content: 'Advertise campaigns for individual, group, or a company here.',
      btn: 'View Campaign',
    },
    credit: {
      title: 'Credit',
      content: 'Buy credits which which will be used for campaign here.',
      btn: 'View Credit'
    },
    contact: {
      title: 'Contact',
      content: 'Save or import your lists of contacts for quick and easy access here.',
      btn: 'View Contact'
    },
  },
  create: {
    info: 'Campaign Information',
    audience: 'Target Audience',
    budget: 'Budget',
    upload: 'File upload',
  },
  modal: {
    title: 'Enter PIN',
    confirm: 'Confirm'
  },
  form: {
    audience: 'Target Audience',
    reach: 'Potential Reach',
    impression: 'Impressions',
    budget: 'Cost & Budget',
    available: 'Available Credit',
    campaign: 'Campaign Credit',
    balance: 'Balance',
    views: 'Views',
    1: {
      title: {
        label: 'Campaign title',
        placeholder: 'Enter campaign title'
      },
      url: {
        label: 'Callback URL',
        placeholder: 'www.mywebsite.com'
      },
      message: {
        label: 'Enter Call To Action Message',
        placeholder: 'Call To Action Message'
      },
      type: 'Campaign type',
      description: {
        label: 'Describe your advertisement',
        placeholder: 'Enter Call To Action Message'
      }
    }
  },
  schedules: {
    title: 'Create schedule',
    form: {
      start: 'Start time',
      end: 'End time',
      days: 'Schedule days',
    }
  },

  listing: {
    stats: {
      total: 'Total Campaigns',
      total_hint: 'All Time',
      active: 'Active',
      active_hint: 'Running Now',
      upcoming: 'Upcoming Campaigns',
      upcoming_hint: 'Starting Soon',
      completed: 'Completed Campaigns',
      completed_hint: 'All time'
    },

    filters: {
      search_placeholder: 'Search campaign by name',
      period_range: 'Period range',
      all_statuses: 'All statuses',
      budget_range: 'Budget range',
      from: 'From',
      to: 'To',
      min_budget: 'Min budget',
      max_budget: 'Max budget',
      apply: 'Apply',
      clear: 'Clear'
    },

    columns: {
      campaign: 'Campaign',
      type: 'Type',
      period: 'Period',
      budget: 'Budget',
      participants: 'Participants',
      performance: 'Performance',
      status: 'Status'
    },

    days_left: '{{count}} days left',
    ended: 'Ended',
    percent_used: '{{percent}}% used',

    actions: {
      view_details: 'View Details',
      preview: 'Preview',
      pause: 'Pause',
      resume: 'Resume',
      delete: 'Delete'
    },

    empty_title: 'No campaigns yet',
    empty_hint: 'Create your first campaign to start engaging customers and driving rewards.',

    table: {
      selected: '{{count}} of {{total}} row(s) selected.',
      page_of: 'Page {{page}} of {{total}}'
    }
  }
};

export default promo;